import {
  mapTaskType,
  mapTeamType,
  mapUserMeType,
  mapUserType,
  TaskType,
  TeamType,
  UserMeType,
  UserType,
  useFindAllTaskListItemsSuspense,
  useFindOwnUserSuspense,
  useFindTaskAssignableTeamsSuspense,
  useFindTaskAssignablePersonsSuspense,
} from '@api';

type UseTasksDataSuspenseReturnType = {
  userData: UserMeType;
  tasks: TaskType[];
  assignableUsers: UserType[];
  assignableTeams: TeamType[];
};

export const useTasksDataSuspense = (): UseTasksDataSuspenseReturnType => {
  const { data: userData } = useFindOwnUserSuspense({
    query: { select: (data) => mapUserMeType(data.data) },
  });
  const { data: tasks } = useFindAllTaskListItemsSuspense({
    query: {
      select: (response) => response.data.map(mapTaskType),
    },
  });
  const { data: assignableUsers } = useFindTaskAssignablePersonsSuspense({
    query: {
      select: (response) => response.data.map(mapUserType),
    },
  });
  const { data: assignableTeams } = useFindTaskAssignableTeamsSuspense({
    query: {
      select: (response) => response.data.map(mapTeamType),
    },
  });

  return {
    userData,
    tasks,
    assignableUsers,
    assignableTeams,
  };
};
